import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from 'vue';

import { MonetizationType } from '@/@types/graphql-types';

import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { useSpinningText } from '@/helpers/composables/useSpinningText';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdsBuy',
  props: {
    title: null,
    offers: null,
    seasonNumber: null
  },
  setup(__props: any) {

const props = __props as {
	title: string;
	offers: TitleDetail['offers'];
	seasonNumber?: number | undefined;
};

const { language } = storeToRefs(useLanguageStore());



const { getOfferTextBlock, getInfoTextBlock, getRTLInfoTextBlock } = useSpinningText(toRefs(props));

const text = computed(() => {
	switch (language.value) {
		case 'fi':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Tällä hetkellä voit katsoa elokuvan',
					'ilmaiseksi mainosten kanssa suoratoistona palvelussa'
				),
				getOfferTextBlock(MonetizationType.Buy, ' tai ostaa sen digitaalisesti palvelussa'),
				'. ',
			];
		case 'ru':
			return [
				getInfoTextBlock(MonetizationType.Ads, 'В настоящее время Вы можете посмотреть', 'на'),
				getOfferTextBlock(MonetizationType.Buy, ' бесплатно с рекламой или купить и скачать на'),
				'. ',
			];
		case 'it':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Adesso puoi guardare',
					'in streaming su ',
					'gratuitamente con avvisi pubblicitari'
				),
				getOfferTextBlock(MonetizationType.Buy, ' o comprarlo scaricandolo online su'),
				'. ',
			];
		case 'de':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Du kannst',
					'legal bei',
					'kostenlos mit Werbeunterbrechungen im Stream anschauen'
				),
				getOfferTextBlock(MonetizationType.Buy, ' oder bei', 'als Download kaufen'),
				'. ',
			];
		case 'pt':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Você pode assistir',
					'legalmente no',
					'gratuitamente com comerciais nos intervalos'
				),
				getOfferTextBlock(MonetizationType.Buy, ' ou no', 'para compar o Download'),
				'. ',
			];
		case 'fr':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'En ce moment, vous pouvez regarder',
					'en streaming gratuit avec publicités sur'
				),
				getOfferTextBlock(MonetizationType.Buy, ' ou le télécharger sur'),
				'. ',
			];
		case 'es':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Actualmente, usted es capaz de ver',
					'forma gratuita con anuncios'
				),
				getOfferTextBlock(MonetizationType.Buy, ' y comprarlo como descarga en'),
				'. ',
			];
		case 'ja':
			return [
				getInfoTextBlock(MonetizationType.Ads, 'は広告付きの動画が', 'で無料配信中です。'),
				getOfferTextBlock(MonetizationType.Buy, '配信版を購入してダウンロードする場合は', 'です'),
				'. ',
			];
		case 'ko':
			return [
				getOfferTextBlock(
					MonetizationType.Ads,
					'현재 ',
					`에서 광고가 포함된 ${props.title}의 영상을 무료 배포 중이며 `
				),
				getOfferTextBlock(MonetizationType.Buy, '', '에서 유료 다운로드하실 수 있습니다.'),
			];
		case 'ro':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'În prezent, puteți viziona',
					'streaming pe',
					'gratuit cu afișare de anunțuri'
				),
				getOfferTextBlock(MonetizationType.Buy, ' sau să-l cumpărați prin descărcare pe'),
				'. ',
			];
		case 'hu':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Jelenleg a(z)',
					'adatfolyamként elérhető a(z)',
					'szolgáltatónál ingyenesen reklámokkal'
				),
				getOfferTextBlock(MonetizationType.Buy, ' vagy letölthető innen:'),
				'. ',
			];
		case 'cs':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Aktuálně máte možnost sledovat',
					'streaming u',
					'zdarma s reklamami'
				),
				getOfferTextBlock(MonetizationType.Buy, ' nebo si jej zakoupit ke stažení u'),
				'. ',
			];
		case 'bg':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'В момента можете да гледате стрийминг на',
					'в',
					'безплатно с реклами в'
				),
				getOfferTextBlock(MonetizationType.Buy, ' или да го купите като изтеглена версия в'),
				'. ',
			];
		case 'ar':
			return [
				getInfoTextBlock(MonetizationType.Ads, 'يمكنكم حالياً مشاهدة', 'الذي يُبث على', 'مجاناً مع الإعلانات'),
				getOfferTextBlock(MonetizationType.Buy, ' أو شرائه عبر تنزيله على'),
				'. ',
			];
		case 'pt':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Atualmente você pode assistir',
					'em streaming via',
					'gratuitamente com anúncios'
				),
				getOfferTextBlock(MonetizationType.Buy, ' ou comprar como download nas platformas:'),
				'. ',
			];
		case 'tr':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Şu an',
					'adlı yapımı',
					'platformunda ücretsiz ama reklamlı olarak izleyebilir veya'
				),
				getOfferTextBlock(MonetizationType.Buy, ' ', 'üzerinden indirmek üzere satın alabilirsiniz'),
				'. ',
			];
		case 'sq':
			return [
				getInfoTextBlock(MonetizationType.Ads, 'Aktualisht, ju mund të shikoni', 'në', 'falas me reklama'),
				getOfferTextBlock(MonetizationType.Buy, ' ose mund ta blini si shkarkim në'),
				'. ',
			];
		case 'pl':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Obecnie możesz oglądać',
					'w streamingu w serwisie',
					'za darmo z reklamami'
				),
				getOfferTextBlock(MonetizationType.Buy, ' lub kupić go jako plik do pobrania w serwisie'),
				'. ',
			];
		case 'ro':
			return [
				getInfoTextBlock(MonetizationType.Ads, 'Acum poți să vezi gratuit', 'pe', ', cu reclame'),
				getOfferTextBlock(MonetizationType.Buy, ' sau să-l descarci contra cost pe'),
				'. ',
			];
		case 'az':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Hazırda siz',
					'üzərindən',
					'yayımını reklamlarla ödənişsiz izləyə bilərsiniz'
				),
				getOfferTextBlock(MonetizationType.Buy, ' və ya onu', 'vasitəsilə alaraq endirə bilərsiniz'),
				'. ',
			];
		case 'el':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Προς το παρόν μπορείτε να παρακολουθήσετε τον τίτλο',
					'με streaming στο',
					'δωρεάν με διαφημίσεις'
				),
				getOfferTextBlock(MonetizationType.Buy, 'ή να τον αγοράσετε ως αρχείο λήψης στο'),
				'. ',
			];
		case 'sr':
			return [
				getInfoTextBlock(MonetizationType.Ads, 'Trenutno možete da gledate', 'strim na', 'besplatno uz oglase'),
				getOfferTextBlock(MonetizationType.Buy, ' ili kupite kao preuzimanje na'),
				'. ',
			];
		case 'sv':
			return [
				getInfoTextBlock(MonetizationType.Ads, 'För närvarande kan du se', 'streama på', 'gratis med annonser'),
				getOfferTextBlock(MonetizationType.Buy, ' eller köpa den som nedladdning på'),
				'. ',
			];
		case 'uk':
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Наразі ви можете дивитися трансляцію',
					'на',
					'безкоштовно з рекламою'
				),
				getOfferTextBlock(MonetizationType.Buy, ' або придбати і завантажити її на'),
				'. ',
			];
		case 'ur':
			return [
				getRTLInfoTextBlock(
					MonetizationType.Ads,
					'فی الحال آپ اشتہارات کے ساتھ مفت میں',
					'پر',
					'اسٹریمنگ دیکھنے کے قابل ہیں۔'
				),
				getOfferTextBlock(MonetizationType.Buy, ' یا اسے', 'پر ڈاؤن لوڈ کے طور پر خریدلیں۔'),
			];

		case 'zh':
			return [
				getInfoTextBlock(MonetizationType.Ads, '目前你可以在', '免费带广告观看'),
				getOfferTextBlock(MonetizationType.Buy, ' 或在', '上购买下载'),
			];
		case 'en':
		default:
			return [
				getInfoTextBlock(
					MonetizationType.Ads,
					'Currently you are able to watch',
					'streaming on',
					'for free with ads'
				),
				getOfferTextBlock(MonetizationType.Buy, ' or buy it as download on'),
				'. ',
			];
	}
});

return { __sfc: true,language, props, getOfferTextBlock, getInfoTextBlock, getRTLInfoTextBlock, text }
}

})